// ----
// This is where all of the site-specific JS goes. This is the site's main JS file, so make your JS defensive.
// It's created using the JS Module Pattern (http://addyosmani.com/resources/essentialjsdesignpatterns/book/#modulepatternjavascript)
// Usage: SCM.SiteJS.functionName();  Can be used anywhere in the application.
// ----

var SCM = SCM || {};

(function (ns, $, accessIcons) {
    // ----
    // Check for JS 
    // ----
    ns.checkForJS = function () {
        $('html').removeClass('no-js');
    };


    // ----
    // Browser Checks
    // ----
    ns.detectIfIE = function () {
        function GetIEVersion() {
            var sAgent = window.navigator.userAgent;
            var Idx = sAgent.indexOf('MSIE');
            // If IE, return version number.
            if (Idx > 0)
                return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)));
            // If IE 11 then look for "Trident" in user agent string.
            else if (!!navigator.userAgent.match(/trident/gi))
                return 11;
            // If IE Edge then look for "Edge" in user agent string.
            else if (!!navigator.userAgent.match(/edge/gi))
                return 13;
            else
                return 0; //It is not IE
        }
        var ieVersion = GetIEVersion();
        if (ieVersion > 0 && ieVersion < 13) {
            $('html').addClass('IE IE-' + ieVersion);
        }
        else if (ieVersion > 12) {
            $('html').addClass('IE IE-Edge');
        }
        else {
            return;
        }
    };

    ns.detectIfFirefox = function () {
        var FF = !(window.mozInnerScreenX == null);
        if (FF) {
            $('html').addClass('firefox');
        }
        else {
            return;
        }
    };

    // ----
    // private variables and functions
    // ----
    var $body = $('body');

    // ----
    // Many Pages / Global
    // ----
    ns.skipToMainContent = function () {
        $('.skipnav').on('click', function () {
            $('#skipNav').focus();
        });
    };

    // SCMP-37582: Hide autosuggest hint inputs from tab order and screen readers.
    // This is a copy of SCM.SiteJS.hideAutoSuggestHintInputs() from the platform
    // theme (client.script.js). GSW's client.script.override.js replaces the
    // platform module entirely, so the function must be replicated here.
    ns.hideAutoSuggestHintInputs = function () {
        $('.microsite-search-term-input-hint').each(function () {
            this.tabIndex = -1;
            this.disabled = true;
            this.setAttribute('aria-hidden', 'true');

            // Also hide the associated label — aria-hidden on the input does not
            // silence its label (they are separate nodes in the accessibility tree).
            const label = document.querySelector('label[for="' + this.id + '"]');
            if (label) {
                label.setAttribute('aria-hidden', 'true');
            }
        });
    };

    ns.globalNavDropdown = function () {
        $('.js-dropdown-trigger').on('click', function (e) {
            $('body').addClass('on-canvas');
            var currentMenu = $(this).next('.js-dropdown');
            e.stopPropagation();
            $('div, nav').not(currentMenu).removeClass('expanded');
            currentMenu.toggleClass('expanded');
            $(document.body).on('click', function () {
                $('.js-dropdown').removeClass('expanded');
                $('body').removeClass('on-canvas');
            });
        });
    };

    ns.closeModals = function () {
        $(document).on('click', '.close-reveal-modal', function () {
            $('.reveal-modal').removeClass('open');
            $('body').removeClass('on-canvas');
        });
        // When user clicks anywhere outside the modal, close it
        $('body').on('click', function (e) {
            if ($(e.target).is('.mobile-mask')) {
                $('.reveal-modal').removeClass('open');
                $('body').removeClass('on-canvas');
            }
        });
    };

    ns.setAllLinksTarget = function () {
        $('a:not([target="_blank"])').each(function () {
            if (linksToAnotherPage(this.href) && linksToExternalPage(this.href)) {
                this.target = '_blank';
                // Instead of binding a Click event to every link on the page, set the
                // `target` attribute to achieve the same effect and improve performance.
            }
        });

        // Returns true if the link actually goes to a different page (as oppposed to being a js only link)
        function linksToAnotherPage(linkHref) {
            return linkHref && (linkHref.startsWith('http') || linkHref.startsWith('/')) && !linkHref.startsWith('#');
        }

        // Returns true if host of the href doesn't match the current page
        function linksToExternalPage(linkHref) {
            if (linkHref.startsWith('/')) {
                return false;
            }

            var hostRegEx = new RegExp('/' + window.location.host + '/');
            return !hostRegEx.test(linkHref);
        }
    };

    ns.initSelfServeNavigation = function () {
        var $currentLink = $('.widget-SelfServeContentNavigationMenu a[href="' + window.location.pathname + '"]');
        $currentLink.addClass('ss-currentPage');
        $currentLink.parents('ul.selfserve-nav-menu-child-list').addClass('open');
        $currentLink.parents('ul.selfserve-nav-menu-child-list').siblings('button.selfserve-subnav-toggle').removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
    };

    ns.toggleSelfServeNavigation = function () {
        $('.selfserve-subnav-toggle, .selfserve-parent-toggle').on('click', function (e) {
            var $this = $(this),
                $nearestSublist = $(this).siblings('.selfserve-sublist');

            e.preventDefault(); // stop button from submitting the page form

            $this.hasClass('icon-general-arrow-filled-right') ? $this.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down') : $this.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right');
            $nearestSublist.hasClass('open') ? $nearestSublist.removeClass('open') : $nearestSublist.addClass('open');
        });
    };

    ns.getViewportWidth = function () {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    };

    ns.initLazyLoad = function () {
        SCM.Utilities.LazyLoad.init('contentFigures');
        SCM.Utilities.LazyLoad.init('inlineGraphics');
        SCM.Utilities.LazyLoad.init('lazy');
    };
	
    ns.showArticleMetadata = function () {
        $('.js-expand-collapse-metadata').on('click', function () {
            $('.js-author-expand-collapse-metadata-wrap').toggleClass('active');
            $('.js-metadata-toggle-icon').toggleClass('icon-general-add');
            $('.js-metadata-toggle-icon').toggleClass('icon-general_minus');
        });
    };
	
    ns.scrollToAwardInfo = function () {
        $(document).on('click', 'a.js-xref-award', function () {

            var $articleTopInfo = $('.js-author-expand-collapse-metadata-wrap');
            if ($articleTopInfo.length && !$articleTopInfo.hasClass('active')) {
                $('.js-expand-collapse-metadata').click();
            }

            var targetAwardGroup = $(this).data('scrollto');
            var $target = $('div.award-group[data-award-id=' + targetAwardGroup + ']');

            if ($('.pg_Article').length) {
                $('html,body').delay(100).animate({
                    scrollTop: $target.offset().top - 65
                }, 250);
            }
            else {
                var $targetScroll = $('.js-content-splitview');
                $targetScroll.delay(100).animate({
                    scrollTop: $targetScroll.scrollTop() + $target.position().top
                }, 250);
            }
        });
    };

    ns.addAuthorFootnote = function () {
        $('.al-author-name').each(function () {
            var $authorNote = $(this).find('.info-card-note .xref-fn');
            if ($authorNote.length && $authorNote.text() === '*') {
                var $footNote = $('<sup/>').append($authorNote.html());
                $footNote.insertAfter($(this).find('.linked-name'));
                $authorNote.remove();
            }
            if ($(this).find('.info-author-correspondence').length) {
                $(this).find('.linked-name').append('<i class="icon-corresponding_author"></i>');
            }
        });
    };


    ns.showHideDropDown = function () {
        $('.selectDropdown').on('click', function (e) {
            $('.dropdown').hide().removeClass('open');
            e.stopPropagation();
            $(this).siblings('.dropdown').slideToggle('300', 'linear').toggleClass('open');
        });

        $(document).click(function () {
            $('.dropdown').hide().removeClass('open');
        });
    };


    ns.showMoreRelatedContent = function (viewMoreSelector, hideMeSelector) {
        $(viewMoreSelector).click(function () {
            var $this = $(this);
            $this.closest('.related-section-box, .widget-RelatedBookContent').find(hideMeSelector).toggleClass('show-item');
            $this.toggleClass('show-less').find('i').toggleClass('icon-show').toggleClass('icon-hide');
            $this.hasClass('show-less') ? $this.find('span').text('See Less') : $this.find('span').text('See More');
        });
    };


    ns.showSpinner = function () {
        $('.pagination button, .querybuilder-submit').on('click', function () {
            $('.preloader-wrap').removeClass('hide').addClass('active');
        });
    };

    ns.isLoggedIn = function () {
        return App.LoginUserInfo.isIndividualLoggedIn > 0;
    };

    // ----
    // START: Mobile Site Nav & Search
    // ----

    ns.toggleSearchCover = function () {
        if ($('.sf-facet').length) {
            $('.sf-facet').click(function () {
                $(document).ajaxStart(function () {
                    $('.info-inner-cover').removeClass('uncovered');
                    $('.info-inner-cover').addClass('covered');
                });
                $(document).ajaxComplete(function () {
                    $('.info-inner-cover').removeClass('covered');
                    $('.info-inner-cover').addClass('uncovered');
                });
            });
        }
    };

    // ----
    // START: Responsive Left Column
    // ----
    ns.toggleResponsiveLeftColumn = function () {
        $(document.body).removeClass('noscroll'); // remove if page reloads as a result of a filter being selected

        $('main').on('click', '.toggle-left-col__search, .toggle-left-col__article', function (e) {
            e.preventDefault();
            $(document.body).addClass('noscroll');
            $('.page-column--left').show();

            $(document).ajaxComplete(function () {
                $(document.body).removeClass('noscroll');
            });

        });

        // due to designs, Issue has a different mobile layout
        $('.toggle-left-col__issue').on('click', function (e) {
            e.preventDefault();
            $(document.body).addClass('noscroll');
            $('.issue-dropdown-wrap').hide();
            $('.responsive-issue-nav').show();
        });

        $('.toggle-left-col__close').on('click', function (e) {
            e.preventDefault();
            $(document.body).removeClass('noscroll');
            $('.page-column--left, .responsive-issue-nav, .issue-dropdown-wrap').removeAttr('style');
        });
    };

    // ----
    // Advanced Search Page
    // ----
    ns.initDatePicker = function () {
        if ($('.pg_AdvancedSearch, .pg_advancedsearch').length && $('#startDateAuthor').length) {
            $('#startDateAuthor, #endDateAuthor, #startDateSemanticSearch, #endDateSemanticSearch').datepicker();
        }
    };

    // ----
    // Content Pages
    // ----

    ns.showFullAuthorList = function () {
        var $showMoreLink = $('.meta-authors--etal');
        var $remainingAuthors = $('.meta-authors--remaining');


        $showMoreLink.on('click', function (e) {
            e.preventDefault();
            $showMoreLink.removeClass('is-active');
            $showMoreLink.attr('aria-hidden', true);

            $remainingAuthors.addClass('is-active');
            $remainingAuthors.attr('aria-hidden', false);

        });
    };

    // lazy load is triggered by scroll. If we append this content into a modal -- it might not appear.
    // This forces the images to appear
    ns.showImages = function ($obj) {
        $obj.find('.contentFigures').each(function () {
            var elem = $(this);
            if (elem.attr('src').toLowerCase().indexOf('grey.gif') >= 0) {
                elem.attr('src', elem.attr('data-original'));
            }
        });
    };


    // There is generic modal div wrapper in site.master where we append any content that needs to be put in a modal
    ns.openRevealModal = function ($obj) {
        var modal = $('#revealModal');
        modal.find('#revealContent').empty().prepend($obj.children().clone());
        modal.closest('.reveal-modal').addClass('open');
        $(document.body).addClass('on-canvas');
        SCM.SiteJS.showImages(modal);
        SCM.SiteJS.restrictedImages();
    };

    ns.processFigGroup = function (modalTriggerId, $groupContainerDiv) {
        $('.reveal-modal').removeClass('open');
        var $figGroupItems = $('[reveal-group-id~="' + modalTriggerId + '"]');
        if ($figGroupItems.length && $groupContainerDiv.length) {
            if (!$groupContainerDiv.children().length) {
                if ($figGroupItems.length) {
                    $figGroupItems.each(function () {
                        $groupContainerDiv.append($(this).clone().removeClass('hide'));
                    });
                }
            }
            $('body').addClass('on-canvas');
            $groupContainerDiv.addClass('open');
            SCM.SiteJS.showImages($groupContainerDiv);
            SCM.SiteJS.restrictedImages();
        }
    };
    // The fig-group's group-level caption renders in the group's own figure-table-wrapper,
    // which sits before the child figures. Move it below the last child figure of the
    // group so the caption reads after the figures it describes.
    ns.positionFigGroupCaptions = function () {
        var $groups = $('.js-main [reveal-group-container-id]');
        if (!$groups.length) {
            return;
        }
        var wrapperSelector = '.figure-table-wrapper, .article-section-wrapper';
        var $allWrappers = $('.js-main').find(wrapperSelector);
        $groups.each(function () {
            var groupId = $(this).attr('reveal-group-container-id');
            var $groupWrap = $(this).closest(wrapperSelector);
            var $caption = $groupWrap.children('.caption').first();
            var $lastChild = $allWrappers.filter(function () {
                return this !== $groupWrap[0] && $(this).find('.fig-section[reveal-group-id~="' + groupId + '"]').length;
            }).last();
            if ($caption.length && $lastChild.length) {
                $caption.insertAfter($lastChild);
            }
        });
    };

    ns.processNonFigGroup = function (revealId, needSubscriptionModal) {
        // content-id might contain multiple, space-separated IDs
        // (P.S. the "i" at the end means "case-insensitive"! it's standard CSS, apparently!)
        var revealContent = $('.js-main [content-id~="' + revealId + '" i]');

        if (revealId.length && !revealContent.length) {
            var resArry = revealId.split(' ');
            if (resArry.length) {

                var rangeContent = ns.getAllReferencesInRange(resArry);
                revealContent = rangeContent.html().length > 0 ? rangeContent : '';
            }
        }

        // Brightcove HTML5 player doesn't work with cloned content
        if ($(revealContent).hasClass('video-modal') || $(revealContent).hasClass('audio-modal')) {
            SCM.Utilities.Reveal.open(revealContent);
            return;
        }

        // this is for figures inside boxed-text
        var targetModal = $('.reveal-modal[content-id="' + revealId + '"]');
        if (targetModal.length) {
            SCM.Utilities.Reveal.open(targetModal);
            return;
        }

        // Found the figure or table? Open it in reveal modal. Otherwise, you must not have access to the content and
        // we'll show you the need account message.
        revealContent.length ? SCM.SiteJS.openRevealModal(revealContent) : SCM.Utilities.Reveal.open(needSubscriptionModal);
    };

    ns.revealFigsTablesInModal = function () {
        var modalTriggerElems = '.xref-fn, .link-reveal, .table-graphic, .caption-title';

        var $needSubscriptionModal = $('#NeedSubscription');

        $body.on('click', modalTriggerElems, function () {
            var $this = $(this);
            var rightPaneItem = $this.hasClass('xref-bibr');
            if ($('.pg_articlesplitview').length > 0 && rightPaneItem) {
                return;
            }

            var revealId = $this.attr('reveal-id') ? $this.attr('reveal-id') :
                ($this.attr('data-reveal-id') ? $this.attr('data-reveal-id') : $this.attr('data-id'));

            var $groupContainerDiv = $('.js-main div[reveal-group-container-id="' + revealId + '" i]');

            if ($groupContainerDiv.length) {
                SCM.SiteJS.processFigGroup(revealId, $groupContainerDiv);
            } else {
                SCM.SiteJS.processNonFigGroup(revealId, $needSubscriptionModal);
            }
        });

    };


    ns.getAllReferencesInRange = function (elem, content, endValue) {
        var nextElem = elem.next();
        var revealId = nextElem.attr('content-id');
        if (revealId.length) {
            content.append(nextElem.children().clone());
            var endRange = revealId === endValue || revealId === endValue.toLowerCase();
            if (!endRange) {
                ns.getAllReferencesInRange(nextElem, content, endValue);
            }
        }
        return content;
    };


    ns.showUnAuthenticatedSpans = function () {
        // For un-authenticated users, replace reveal-modal links with spans, since target of link is 99.99% likely to be missing
        $(document).ready(function () {
            var hasAccess = $('div[data-widgetname="ArticleFulltext"] span#UserHasAccess').attr('data-userHasAccess');
            if (hasAccess && hasAccess.length && hasAccess.toLowerCase() === 'false') {
                var revealModalLinks = $('div[data-widgetname="ArticleFulltext"] a[data-reveal-id]');
                revealModalLinks.each(function () {
                    $(this).replaceWith(function () {
                        var anchorHtml = this.innerHTML;
                        return '<span>' + anchorHtml + '</span>';
                    });
                });
            }
        });
    };

    // ----
    // START: Site Header
    // ----

    var signInLoaded = false;

    ns.loadSignInForm = function () {
        var $mobileSignInForm = $('.mobile-account-dropdown ul li ul'),
            $desktopSignInForm = $('.dropdown-panel-signin'),
            $signInPageForm = $('#sign-in-page'),
            returnUrl = SCM.SiteJS.getDefaultReturnUrl();

        if (!signInLoaded) {
            // Get the login form markup with AJAX
            var widgetUrl = (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/SignIn/LoginForm/LoginFormPopup?returnUrl=' + encodeURIComponent(returnUrl);
            $.ajax({
                url: widgetUrl,
                cache: false,
                success: function (data) {
                    // Insert markup into both desktop & mobile panels
                    $desktopSignInForm.html(data);
                    $mobileSignInForm.html(data);
                    SCM.AddReturnUrlToSocietyLinks();
                    signInLoaded = true;
                    ns.setAutoLoginCookieUponSSOLinkClick();
                }
            });
        }
        else {
            ns.setAutoLoginCookieUponSSOLinkClick();
        }
    };


    ns.initSigninForm = function () {
        //DESKTOP signin from dropdown
        $('.site-theme-header-menu-item .dropdown-toggle.signin').on('click', function (e) {
            e.preventDefault();
            ns.loadSignInForm();
        });

        // button login
        $(document).on('click', '.signin-form .signin-button', function (e) {
            var $closestSigninForm = $(this).closest('.signin-form'),
                $closestSpinner = $closestSigninForm.find('.preloader-wrap');
            e.preventDefault();
            e.stopPropagation();

            SCM.SiteJS.Login($closestSigninForm, $closestSpinner);
        });

        // Enter key login
        $(document).on('keypress', '.signin-form input.username, .signin-form input.password', function (e) {
            var $closestSigninForm = $(this).closest('.signin-form'),
                $closestSpinner = $closestSigninForm.find('.preloader-wrap');
            var code = e.keyCode || e.which;
            if (code === 13) {
                e.preventDefault();
                SCM.SiteJS.Login($closestSigninForm, $closestSpinner);
            }
        });

        // Log Out
        $(document).on('click', '.signout-button', function (e) {
            // don't do ajax call, since the logouthandler may issue its own redirection e.g. Single Sign out. It will be default go back to /.
            e.preventDefault();
            window.top.location.assign('/LogoutHandler.ashx');
        });

        // Institutional login, append returnUrl
        $(document).on('click', 'a.institutional-login-link', function (e) {
            e.preventDefault();

            var targetUrl = $(this).attr('href');

            var targetUrlLowerCase = targetUrl.toLowerCase();

            // skip if the target already has a returnUrl, or if current page is the target 
            // For simplicity, we won't check possibly various formats in front of the pathname - a mismatch won't be a big deal
            if (!(targetUrlLowerCase.indexOf('returnurl=') > 0 || window.top.location.href.toLowerCase().indexOf(targetUrlLowerCase) >= 0)) {
                // pass through returnUrl from current page
                var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');

                if (returnUrl === undefined || returnUrl === null) {
                    returnUrl = window.top.location.href; // full URL, in case there is a sub domain while a shibboleth login can only have one default sign in page
                }

                // append returnUrl to target
                if (returnUrl !== undefined && returnUrl !== null && returnUrl.length > 0) {
                    targetUrl = $.param.querystring(targetUrl, 'returnUrl=' + encodeURIComponent(returnUrl));
                }
            }

            window.top.location.assign(targetUrl);
        });

        // Shibboleth login
        $(document).on('click', 'a.shibboleth-signin', function () {
            var currLocation = window.top.location;
            var shibbolethHandlerUrl = currLocation.origin + '/SHIBBOLETH?dest=' + encodeURIComponent(currLocation.pathname + currLocation.search);
            var shibbolethUrl = $(this).data('target').replace('{0}', encodeURIComponent(shibbolethHandlerUrl));

            window.top.location = shibbolethUrl;
        });

    };

    ns.initLoginFormDropdown = function () {
        $('.signin-form').on('click', 'a[data-target="register"]', function (e) {
            e.preventDefault();

            var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');
            if (returnUrl === undefined || returnUrl === null) {
                returnUrl = location.pathname + location.search;
            }

            window.top.location.assign('/my-account/register?returnUrl=' + encodeURIComponent(returnUrl));
        });
    };

    ns.Login = function ($formContainer, $formSpinner) {
        
        var username = $formContainer.find('input.username').val();
        var password = $formContainer.find('input.password').val();
        var recaptchaResponse = SCM.Captcha.GetCaptchaResponse($formContainer);
        var captchaWidgetInstanceName = SCM.Captcha.GetCaptchaInfo().ReCaptchaWidgetControlId;
        if (username.length === 0 || password.length === 0) {
            $formContainer.find('.error').show();
            return;
        }

        $formSpinner.removeClass('hide');
        $('.error, .no-permission').hide();

        SCM.Ajax.post('/LoginHandler.ashx', { user: username, pass: password, recaptchaResponse: recaptchaResponse , captchaInstanceName:captchaWidgetInstanceName})
            .expectJson()
            .then(function (result) {
                if (result.LoginSuccess) {
                    SCM.SiteJS.loginReturnBack();
                } else if (result.UnverifiedUser) {
                    var $noPerm = $formContainer.find('.error');
                    $noPerm.text(result.ErrorMessage);
                    $noPerm.show();
                    SCM.Captcha.ResetCaptcha($formContainer);
                } else {
                    $formContainer.find('.error').show();
                    SCM.Captcha.ResetCaptcha($formContainer);
                }
            })
            .catch(function (reason) {
                console.error('Login failure: ' + reason);
                $formContainer.find('.error').show();
            })
            .finally(function () {
                $formSpinner.addClass('hide');
            });

    };

    ns.loginReturnBack = function () {
        var returnUrl = SCM.SiteJS.getDefaultReturnUrl();

        // exclude URLs which can only be accessed before sign-in
        var regex = /^\/((\w+\/)?sign-in|my-account\/forgot-password|my-account\/reset-password|my-account\/register|institutional-login)/i;
        if (regex.test(returnUrl)) {
            returnUrl = '/';
        }

        // only allow same domain
        if (returnUrl !== '/') {
            var returnDomainTest = returnUrl.match(/\/\/([^/]+\.)?([^./]+\.[^./]+)/i);
            if (returnDomainTest !== null && returnDomainTest[2].toLowerCase() !== window.top.location.hostname.match(/(.*\.)?([^.]+\.[^.]+)/i)[2].toLowerCase()) {
                returnUrl = '/';
            }
        }

        window.top.location.assign(returnUrl);
    };

    //Strictly Neccessary Cookie
    ns.setAutoLoginCookieUponSSOLinkClick = function () {
        $('.widget-ExternalLogin a').off('click').on('click', function () {
            var hrefValue = $(this).attr('href');
            if (hrefValue && hrefValue.length && hrefValue.indexOf('elpId=') < 0) {
                var date = new Date();
                // 1 hour * 60 minutes * 60 seconds * 1000 milliseconds
                date.setTime(date.getTime() + 1 * 60 * 60 * 1000);
                var expires = '; expires=' + date.toGMTString();
                document.cookie = 'ForceAutoLogin=AutoLogin=GeoScienceWorld' + expires;
            }
        });
    };

    // Constructs a returnUrl
    ns.getDefaultReturnUrl = function () {
        var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');
        if (returnUrl) {
            returnUrl = decodeURIComponent(returnUrl);
        }

        if (returnUrl === undefined || returnUrl === null || returnUrl.length === 0) {
            returnUrl = SCM.JSUtility.getSearchParamByName('redirectUrl'); // for backward compatibility
        }

        if (returnUrl === undefined || returnUrl === null || returnUrl.length === 0) {
            // Use full current URL (without hash) to ensure proceedings pages redirect correctly
            returnUrl = window.top.location.pathname + window.top.location.search;
        }

        return returnUrl;
    };

    // returns the canonicalUrl of this page, or an empty string
    ns.getCanonicalUrl = function () {
        var canonicalUrl = $('link[rel="canonical"]').attr('href');

        if (canonicalUrl === undefined || canonicalUrl === null || canonicalUrl.length === 0) {
            return '';
        }

        return canonicalUrl;
    };

    ns.initPaginationListener = function () {
        $('.al-pageNumber,.sr-nav-previous,.sr-nav-next').off('click').on('click', function () {
            if (!$(this).hasClass('currentPage')) {
                $('.preloader-wrap').removeClass('hide');
                var url = $(this).attr('data-url');
                SCM.SearchResults.doSolrSearch({ queryString: url });
            }
        });
    };


    // ----
    // Search Results
    // ----
    ns.initSearchResultsSort = function () {
        var $sortOrderSelectOption = $('.sort-order-select-option'),
            $sortOrderSelect = $('.sort-order-select'),
            $preloaderWrap = $('.preloader-wrap');

        $sortOrderSelect.on('change', function () {
            var qs = $(this).val();
            SCM.SearchResults.doSolrSearch({ queryString: qs, source: 'searchresults' });
        }); // END sortOrderSelect.on('change')

        $sortOrderSelectOption.on('click', function () {
            var lnk = $(this).find('option[value]');
            if (lnk.length) {
                $preloaderWrap.removeClass('hide');
            }
        }); // END sortOrderListItem.on('click')

        ns.initPaginationListener();

    };

    // Disable rightclick on figure context for restricted images.
    ns.restrictedImages = function () {
        $('a.fig-link[restricted]').each(function () {
            var graphicWrap = $(this).parent('div.graphic-wrap');
            var copyrightMessage = $(graphicWrap).children('.copy-right-statement');
            graphicWrap.attr('restricted', '');
            graphicWrap.off('contextmenu').on('contextmenu', function () { // right click
                $(copyrightMessage).toggle();
                return false;
            });
            $(this).click(function () { // left click on link around image
                $(copyrightMessage).toggle();
                return false;
            });
            $(copyrightMessage).click(function () { // left click on copyright message
                $(copyrightMessage).toggle();
                return false;
            });
        });
    };

    ns.adjustRelatedTagsDisplay = function () {
        // step 1: create a variable for each type/row of tags (Keywords, Topic, Subject, etc)
        $('.article-metadata-panel:not(:last)').remove();
        var $articleMetadataPanel = $('.article-metadata-panel').last(),
            $keywordGroupSection = $('.kwd-group'), //output through XSLT template <kwd-group>
            $relatedTopicTags = $('.related-topic-tags'),
            $taxonomies = $('.article-metadata-taxonomies'),
            $tocSections = $('.article-metadata-tocSections'),
            $kwdGroupProceedings = $('.kwd-group-proceedings'), // Solr-indexed Keywords, Topics, and Subjects for proceedings
            $solrMetadataWidget = $('.widget-instance-SolrResourceMetadata_Proceeding'); // GSW-4652: Entire widget container for proceedings

        // GSW-4652: For proceedings pages, move the entire SolrResourceMetadata widget container instead of individual elements
        if ($solrMetadataWidget.length > 0 && $articleMetadataPanel.length > 0) {
            $articleMetadataPanel.append($solrMetadataWidget);
            $articleMetadataPanel.show();
            return; // Exit early - we've moved the entire widget
        }

        // step 2: put those variables into an array
        var $tagContainerArray = [$keywordGroupSection, $kwdGroupProceedings, $relatedTopicTags, $taxonomies, $tocSections];

        if ($articleMetadataPanel.length === 0) {
            // no abstract, use the standalone metadata panel
            $articleMetadataPanel = $('.article-metadata-standalone-panel');
            // make sure the standalone panel isn't empty before showing
        }

        // step 3: cycle through $tagContainerArray
        for (let i = 0; i < $tagContainerArray.length; i++) {
            // step 3b: if current item has content, append to $articleMetadataPanel
            if ($tagContainerArray[i].length) {
                $articleMetadataPanel.append($tagContainerArray[i]);
            }
        }

        if ($articleMetadataPanel.html()) {
            $articleMetadataPanel.show();
        }
    };

    ns.showPdfOnlyLink = function () {
        if ($('.PdfOnlyLink').length && $('.toolbar-item.item-pdf').length) {
            $('.toolbar-item.item-pdf').children().clone().appendTo('.PdfOnlyLink');
        }
    };

    // GSW-4652: Merge keywords from XSLT (database) and Solr sources
    ns.mergeKeywordsFromXsltAndSolr = function () {
        var $xsltKeywords = $('.kwd-group:not(.kwd-group-proceedings)');
        var $solrKeywordsSection = $('.kwd-group-proceedings[data-label="Keywords"]');

        if ($xsltKeywords.length === 0 || $solrKeywordsSection.length === 0) {
            return; // No keywords to merge
        }

        // Extract keywords from XSLT (database)
        var xsltKeywordsList = [];
        $xsltKeywords.find('a, span').each(function() {
            var text = $(this).text().trim();
            if (text && text !== ',') {
                xsltKeywordsList.push(text);
            }
        });

        // Extract keywords from Solr
        var solrKeywordsList = [];
        $solrKeywordsSection.find('a.kwd-part').each(function() {
            var text = $(this).text().trim();
            if (text) {
                solrKeywordsList.push(text);
            }
        });

        // Merge and deduplicate (case-insensitive)
        var mergedKeywords = [];
        var keywordMap = {};

        // Add Solr keywords first
        solrKeywordsList.forEach(function(keyword) {
            var lowerKey = keyword.toLowerCase();
            if (!keywordMap[lowerKey]) {
                keywordMap[lowerKey] = keyword;
                mergedKeywords.push(keyword);
            }
        });

        // Add XSLT keywords if not already present
        xsltKeywordsList.forEach(function(keyword) {
            var lowerKey = keyword.toLowerCase();
            if (!keywordMap[lowerKey]) {
                keywordMap[lowerKey] = keyword;
                mergedKeywords.push(keyword);
            }
        });

        // Rebuild the Solr Keywords section with merged keywords
        if (mergedKeywords.length > 0) {
            var keywordsHtml = '<strong>Keywords: </strong>';
            mergedKeywords.forEach(function(keyword, index) {
                if (index === mergedKeywords.length - 1) {
                    // Last keyword - no comma
                    keywordsHtml += '<a class="kwd-part kwd-main" href="javascript:;" data-keyword="' + keyword + '">' + keyword + '</a>';
                } else {
                    keywordsHtml += '<a class="kwd-part kwd-main" href="javascript:;" data-keyword="' + keyword + '">' + keyword + '</a>, ';
                }
            });

            $solrKeywordsSection.html(keywordsHtml);
        }

        // Hide original XSLT keywords
        $xsltKeywords.hide();
    };


    // ----
    // START: Acessibility Functions (ARIA)
    // ----

    ns.ariaToggleTable = function (ariaTarget) {
        var $ariaControl = $(ariaTarget + '-button'),
            $ariaIcon = $ariaControl.children('.collapse-icon');

        $ariaControl.on('click', function (e) {
            e.preventDefault();
            //toggle aria-expanded attribute
            $ariaControl.attr('aria-expanded') === 'true' ? $ariaControl.attr('aria-expanded', 'false') : $ariaControl.attr('aria-expanded', 'true');
            // toggle arrow
            $ariaIcon.hasClass('icon-general-arrow-filled-down') ? $ariaIcon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right') : $ariaIcon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
            //toggle active class & state on the target table to show/hide it
            $(ariaTarget).toggleClass('hide');
            $(ariaTarget).attr('aria-hidden') === 'false' ? $(ariaTarget).attr('aria-hidden', 'true') : $(ariaTarget).attr('aria-hidden', 'false');
        });
    };

    ns.initAriaControls = function () {
        //tables on: academic.oupdev.silverchair.com/[JOURNAL]/subscribe/SingleIssue & CurrentYear
        var $tables = $('[id^=collapsible-table-]');
        $tables.each(function (index) {
            SCM.SiteJS.ariaToggleTable('#collapsible-table-' + index);
        });
    };

    // ----
    // START: Issue Page: ArticleListAccess.cshtml
    // ----
    ns.abstractMathJax = function () {
        if ($('.abstract-response-placeholder').length) {
            window.MathJax.typesetPromise(['.abstract-response-placeholder'])
                .catch((err) => console.log(err.message));
        }
    };

    ns.initializeArticlePdfLinks = function () {
        var currentArticleList = $('#ArticleList h5.item-title');

        if (currentArticleList != null) {
            currentArticleList.each(function () {
                var article = $(this);
                var pdfLink = article.parent().find('.article-pdfLink');

                if (pdfLink != null) {

                    if (hasAccess(article) || SCM.SiteJS.isLoggedIn()) {
                        navigateToPdfOnClick(pdfLink);
                    }
                    else {
                        navigateToSignInPageOnClick(pdfLink);
                    }
                }
            });
        }

        function hasAccess(article) {
            // accessIcons are passed in at the very top of this file
            var articleId = article.data('resourceIdAccess');
            if (accessIcons != null && articleId != null) {
                var accessIcon = SCM.SiteJS.getAccessIcon(articleId, accessIcons);
                return accessIcon != null && accessIcon.icon !== 'icon-availability_cart';
            }

            return false;
        }

        function removeOnClickEvents(obj) {
            // Guards against a 2nd click event being added after the page has been updated via ajax
            // (see ajaxComplete)
            obj.off('click');
        }

        function navigateToPdfOnClick(pdfLink) {
            removeOnClickEvents(pdfLink);

            var articlePdfHandler = App.SiteURL + 'HTTPHandlers/ArticlePdfHandler.ashx';
            var journal = pdfLink.data('journal');
            var mmId = pdfLink.data('pdf-id');

            if (mmId != null && journal != null) {
                pdfLink.on('click', function (e) {
                    e.preventDefault();
                    window.open(articlePdfHandler + '?journal=' + journal + '&multimediaId=' + mmId, '_blank');
                });
            }
        }

        function navigateToSignInPageOnClick(pdfLink) {
            removeOnClickEvents(pdfLink);
            var returnUrl = SCM.SiteJS.getDefaultReturnUrl();

            pdfLink.on('click', function (e) {
                // client override for GSW-2695
                e.preventDefault();
                var articleLink = $(this).parents('.al-article-items').find('.viewArticleLink').attr('href');
                if (articleLink) {
                    window.location = articleLink;
                }
                else {
                    window.location = '/sign-in?returnUrl=' + encodeURIComponent(returnUrl);
                }
            });
        }
    };

    // ----
    // End: Issue Page: ArticleListAccess.cshtml
    // ----

    ns.triggerFppOnRedirect = function () {
        if (typeof IsUserFromRedirectSite !== 'undefined' && IsUserFromRedirectSite == 'true') {
            $('.firstPagePreviewImage').click();
        }
    };

    // For simple modals that don't copy content
    ns.modalManager = function () {
        /***********************************************************************
        * NOTE: Modals with additional logic have not been included
        * modals to add (trigger : target):
        * '.js-open-marketing-modal' : ???,
        * ********************************************************************/
        let modalArray = {
            '#revealModal': '#revealContent',
            '.js-open-saveSearch-modal': '.solrSearchSaveModel',
            '.js-add-edit-trigger': '#journalAddEditDiv',
            '.js-open-alert-modal[data-user-logged-in="True"]': '.userAlertSignUpModal',
            '[data-reveal-id="addArticleUpdateAlert"]': '#AddAlert',
            '[data-reveal-id="emailUsernameModal"]': '#emailUserName',
            '.firstPagePreviewImage': '#divFirstPagePreview',
            '[data-reveal-id="getCitations"]': '#getCitations'
        };
        
        function addOnClickBehavior(trigger, target) {
            $(document.body).on('click', trigger, function () {

                var userLoginState = $(trigger).data('userloggedin');

                if (trigger !== '.js-open-saveSearch-modal' || !userLoginState) {
                    if (!(trigger === '.js-open-saveSearch-modal' && userLoginState.toLowerCase() === 'false')) {
                        $(target).closest('.reveal-modal').addClass('open');
                        $(document.body).addClass('on-canvas'); // the grey BG
                    }
                }
            });
        }

        for (var key in modalArray) {
            addOnClickBehavior(key, modalArray[key]);
        }
    };

    ns.mobileNav = function () {
        var $myAcctTabsInnerWrap = $('.myaccount-tabs-inner-wrap');
        var $mobileNavIcon = $('.mobile-nav-icon');

        // mobile page navigation
        $(document).on('click', '.myaccount-mobile-nav', function (e) {
            e.stopPropagation();
            $myAcctTabsInnerWrap.toggle();
            if ($mobileNavIcon.hasClass('icon-general-arrow-filled-down')) {
                $mobileNavIcon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-up');
            } else {
                $mobileNavIcon.removeClass('icon-general-arrow-filled-up').addClass('icon-general-arrow-filled-down');
            }
        });

        $(document).click(function () {
            $myAcctTabsInnerWrap.hide().removeAttr('style');
        });
    };
    
    // ----
    // Initialization functions
    // ----
    ns.init = function () {
        ns.checkForJS();
        ns.detectIfIE();
        ns.detectIfFirefox();
        ns.skipToMainContent();
        ns.hideAutoSuggestHintInputs();
        ns.globalNavDropdown();
        ns.initAriaControls();
        ns.initSearchResultsSort();
        ns.initLazyLoad();
        SCM.AuthorLinks.init();
        SCM.PubHistory.registerToggle();
        ns.showFullAuthorList();
		ns.showArticleMetadata();
		ns.scrollToAwardInfo();
        ns.addAuthorFootnote();
        ns.showHideDropDown();
        ns.showMoreRelatedContent('.grw-viewmorelink', '.grw-hide-me');
        ns.showMoreRelatedContent('.mrw-viewmorelink', '.mrw-hide-me');
        ns.showSpinner();
        ns.toggleResponsiveLeftColumn(); // renamed
        ns.restrictedImages();
        ns.initSigninForm(); // AJAX
        ns.initSelfServeNavigation();
        ns.toggleSelfServeNavigation();
        ns.setAllLinksTarget();
        ns.showPdfOnlyLink();
        SCM.gdprCookieBanner.init();
        ns.mobileNav();
        SCM.Toolbar.stickyToolbar();
        ns.scrollToTarget();
    };

    ns.windowLoadInit = function () {
        ns.initDatePicker();
        ns.revealFigsTablesInModal();
        ns.positionFigGroupCaptions();
        ns.showUnAuthenticatedSpans();
        ns.toggleSearchCover();
        ns.modalManager();
        ns.triggerFppOnRedirect();
        ns.closeModals();
    };

    ns.initArticleTopInfoAccessOptions = function () {
        // e.g. /acn
        var siteName = window.location.pathname.substring(0, window.location.pathname.indexOf('/', 2));
        var signInUrl = siteName + '/sign-in?returnUrl=' + encodeURIComponent(window.location.pathname + window.location.search);

        var $options = $('.article-top-info-user-restricted-options');

        $options.find('.article-top-info-sign-in').attr('href', signInUrl);

    };
    
    // A hash deep link should position the article once, on arrival. Theme.stickySplitviewNav
    // calls this on every scroll event, so while the hash remains in the URL every attempt to
    // scroll away would drag the reader back to the cited section. Once the authoritative pass
    // on window load has positioned the article, stop responding to those scroll-driven calls.
    let hashScrollLocked = false;

    // lockAfterScroll: pass true only from the window load pass, when images and panel geometry
    // are final. The document-ready pass runs too early to be trusted, so it must not lock.
    ns.scrollToTarget = function (lockAfterScroll) {
        if (hashScrollLocked) {
            return;
        }
        var hash = window.location.hash;
        if (hash != '' && hash != undefined) {
            var escapedHash = hash.replace(/([;?%&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
            var target = $(escapedHash);
            var pixelOffset = 60;
            var $splitViewContent = $('.js-content-splitview');
            if (target.length && $splitViewContent.length) {
                var scroll = target.offset().top +
                    $splitViewContent.scrollTop() -
                    $splitViewContent.offsetParent().offset().top - pixelOffset;
                var $articleSplitView = $('.pg_articlesplitview');

                if (scroll > $('.splitview__wrapper').offset().top - 10) {
                    $articleSplitView.addClass('stuck js-stuck');
                    $articleSplitView.removeClass('sticky-splitview-nav js-sticky-splitview-nav');
                }
                else {
                    $articleSplitView.removeClass('stuck js-stuck');
                    $articleSplitView.addClass('sticky-splitview-nav js-sticky-splitview-nav');
                }
                $splitViewContent.scrollTop(target.offset().top +
                    $splitViewContent.scrollTop() -
                    $splitViewContent.offsetParent().offset().top - pixelOffset);

                if (lockAfterScroll) {
                    hashScrollLocked = true;
                }
            }
        }
    };

    ns.repositionToHashTarget = function () {
        hashScrollLocked = false;
        ns.scrollToTarget(true);
    };
})(SCM.SiteJS = SCM.SiteJS || {}, jQuery, SCM.AccessIcons);


// ----
// Where all modules get initialized
// ----
// A closure around doc.ready, window.load, window resize, and Ajax Complete so we can safely use $
(function ($, undefined) {
    var $resizeTimer;
    var $pageColumnLeft = $('.page-column--left');
    var setMobileClass = function () {
        SCM.SiteJS.getViewportWidth() <= 1023 ? $pageColumnLeft.addClass('mobile') : $pageColumnLeft.removeClass('mobile');
    };

    // Set listener for alerts widget in case it's loaded dynamically.
    initAlerts = function () {
        if ($('.widget-Alerts').length || $('.js-contextual-alert-signup').length || $('.js-open-alert-modal').length) {
            Theme.Alerts && Theme.Alerts.init && Theme.Alerts.init();
            // Also trigger alert modal if redirected from login with hash parameter
            Theme.Alerts && Theme.Alerts.triggerAlertModalOnRedirect && Theme.Alerts.triggerAlertModalOnRedirect();
            Theme.Alerts && Theme.Alerts.triggerContextualAlertModalOnRedirect && Theme.Alerts.triggerContextualAlertModalOnRedirect();
        }
    }

    $(window).on('SCM-SharedWidgets-AsyncWidgetLoader_LOADED', initAlerts);
 
    // Window Resize Event
    // all functions contained within the the resize & scroll events should be throttled or debounced in some way.
    // Example in SCM.JSUtility.js;
    $(window).on('resize', function () {
        clearTimeout($resizeTimer);
        $resizeTimer = setTimeout(function () {
            setMobileClass();
        }, 10); // in milliseconds
    });

    // Window Load Event: Images done loading
    $(window).on('load', function () {
        SCM.SiteJS.windowLoadInit();
        SCM.SiteJS.adjustRelatedTagsDisplay();

        var path = window.location.pathname.toLowerCase();
        if (path.indexOf('/proceedings/') !== -1 || path.indexOf('/proceedings-split/') !== -1) {
            SCM.SiteJS.mergeKeywordsFromXsltAndSolr();
        }

        if (!SCM.SplitScreen.isSplitScreen()) {
            Theme.HashHandler.scrollToSubSection();
        } else {
            SCM.SiteJS.scrollToTarget(true);

            $(window).on('SCM-SharedWidgets-AsyncWidgetLoader_LOADED', function () {
                SCM.SiteJS.scrollToTarget(true);
            });

            $(window).on('hashchange', function () {
                SCM.SiteJS.repositionToHashTarget();
            });
        }
    
        if ($('.widget-Alerts').length) {
            Theme.Alerts && Theme.Alerts.triggerAlertModalOnRedirect && Theme.Alerts.triggerAlertModalOnRedirect();
            Theme.Alerts && Theme.Alerts.triggerContextualAlertModalOnRedirect && Theme.Alerts.triggerContextualAlertModalOnRedirect();
        }

    });

    // Document Ready Event: DOM fully loaded
    $(function () {
        Theme.CrossmarkButton && Theme.CrossmarkButton.init && Theme.CrossmarkButton.init();
        setMobileClass();
        SCM.SiteJS.init(); // init general JS module for site
        SCM.Toolbar.init(); // init Toolbar module from client.toolbar.js
        SCM.PDFAccess.init(); // init PDF module from scm.sharedcontrols.pdfaccess.js
        SCM.SiteJS.setAccessIcons();
        SCM.SiteJS.initializeArticlePdfLinks();
        SCM.JumpLinks.init();
        SCM.AddReturnUrlToSocietyLinks();
        if ($('.widget-ArticleFulltext').length > 0) {
            SCM.ArticleFulltext.init();
        }
        if ($('body').hasClass('pg_articlesplitview')) {
            SCM.SplitScreen.init();
        }
        SCM.SiteJS.initLazyLoad();
        Theme.Store && Theme.Store.init && Theme.Store.init();
        SCM.Dropdowns && SCM.Dropdowns.init && SCM.Dropdowns.init();
        Theme.ArticleAbstract && Theme.ArticleAbstract.init && Theme.ArticleAbstract.init();
        Theme.BookAbstract && Theme.BookAbstract.init && Theme.BookAbstract.init();
        Theme.ChapterAbstract && Theme.ChapterAbstract.init && Theme.ChapterAbstract.init();
        Theme.ConferenceVolumeSelector && Theme.ConferenceVolumeSelector.init && Theme.ConferenceVolumeSelector.init();
        Theme.ContactUsForm && Theme.ContactUsForm.init && Theme.ContactUsForm.init();
        Theme.CookiePro && Theme.CookiePro.loadCookiesIfNotEnabled && Theme.CookiePro.loadCookiesIfNotEnabled();
        Theme.NewAndPopular && Theme.NewAndPopular.init && Theme.NewAndPopular.init();
        Theme.PeerReview && Theme.PeerReview.init && Theme.PeerReview.init();
        SCM.JwPlayer && SCM.JwPlayer.init && SCM.JwPlayer.init();

        if ($('.widget-MyAccount').length) {
            Theme.MyProfile && Theme.MyProfile.init && Theme.MyProfile.init();
        }

        if ($('.widget-RegisterUser').length) {
            Theme.RegisterUser && Theme.RegisterUser.init && Theme.RegisterUser.init();
        }

        if ($('.widget-InstitutionSignIn').length) {
            Theme.InstitutionSignIn && Theme.InstitutionSignIn.init && Theme.InstitutionSignIn.init();
        }

        if ($('.widget-ShibbolethSignin').length) {
            Theme.ShibbolethSignin && Theme.ShibbolethSignin.init && Theme.ShibbolethSignin.init();
        }

        if ($('.solrSearchSaveWidget').length) {
            Theme.SolrSavedSearches && Theme.SolrSavedSearches.init && Theme.SolrSavedSearches.init();
        }

        if ($('.js-my-email-alerts').length) {
            Theme.MyEmailAlerts && Theme.MyEmailAlerts.init && Theme.MyEmailAlerts.init();
        }

        initAlerts();

        if ($('body').hasClass('pg_Issue')) {
            Theme.Issue && Theme.Issue.init && Theme.Issue.init();
        }

        if ($('.js-cadmore-embed-placeholder').length) {
            Theme.Utilities.Cadmore && Theme.Utilities.Cadmore.init && Theme.Utilities.Cadmore.init();
        }

        SCM.SearchAccessibility && SCM.SearchAccessibility.init && SCM.SearchAccessibility.init();
        SCM.SolrSearch.documentReady();
    });



    // Ajax Complete Event
    $(document).ajaxStart(function () {
        $('body').css('cursor', 'wait');

    }).ajaxComplete(function (event, xhr, settings) {
        // init foundation for new DOM elements after new HTML loaded through AJAX
        SCM.SiteJS.initSearchResultsSort();
        SCM.SolrSearch.ajaxComplete();
        SCM.SiteJS.setAccessIcons();
        SCM.SiteJS.initializeArticlePdfLinks();
        SCM.SiteJS.setAllLinksTarget();
        $('body').css('cursor', 'default');
        SCM.SiteJS.abstractMathJax();
        SCM.SiteJS.initLazyLoad();
        SCM.SiteJS.initPaginationListener();
    });

})(jQuery);
